
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// @ts-ignore: allow importing CSS without a type declaration
import '../Tracking/PacifixTracking.css';
// import Logo from '../Logo/Jaimarutilogo.png';
import ShreRamji from '../Logo/Shreeramjilogo.png';
import Swal from "sweetalert2";


interface StatusEntry {
    Destination_name: string;
    LocationName: string;
    Status: string;
    DelvDt: string;
    DelvTime: string;
}

interface TrackingRecord {
    DocketNo: string;
    BookDate: string;
    DelvDT: string;
    ExptDateOfDelvDt: string;
    OriginCity: string;
    DestinationCity: string;
    Consignee_Name: string;
    Status: string;
    DelvTime: string | null;
    VendorAwbNo: string;
    Vendor_Name: string;
    ActualWt: number;
    ChargedWt: number;
    Qty: number;

    EwayBill: string;
    InvoiceNo: string;

    Mode_Code: string;

    Consignee_Mob: string;
    Consignee_Pin: string;

    RecvName: string | null;
    ReceivedMo: string;
    Recvremark: string | null;

    DrsDate: string | null;
    DrsNo: string | null;

    Employee_code: string | null;
    Employee_Mobile: string | null;

    Area: string | null;
    VehicleNo: string | null;

    Location_Code: string | null;

    Manifest_No: string | null;
    Manifest_Dt: string | null;

    From_Dest: string | null;
    ManifestDestination: string | null;

    StatusEntry: StatusEntry[];
}

const ShreeramjiTracking = (): JSX.Element => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    const getTrackingUrl = (awb: string, vendor?: string) => {
        if (!awb) return "#";

        const v = (vendor || "").toUpperCase().trim();

        if (v === "DHL") {
            return `https://www.dhl.com/in-en/home/tracking.html?tracking-id=${awb}&submit=1`;
        }

        if (v === "DPD") {
            return `https://tracking.dpd.de/status/en_US/parcel/${awb}`;
        }

        if (v === "PUROLATOR") {
            return `https://www.purolator.com/en/shipping/tracker?pin=${awb}`;
        }

        return "#";
    };

    // const fetchData = async () => {
    //     try {
    //         if (!searchValue.trim()) {
    //             Swal.fire({
    //                 icon: "warning",
    //                 title: "Enter AWB Number",
    //                 text: "📩 Please enter AWB No to get tracking details",
    //             });
    //             return;
    //         }

    //         // 🔥 AUTO DETECT (CNote vs RefNo)
    //         let url = "";

    //         if (searchValue.length >= 10) {
    //             // 👉 Vendor AWB (refNo)
    //             url = `https://jaimarutilogistics.com/JaiAirTrackingApi/getTrackingData?refNo=${searchValue}`;
    //         } else {
    //             // 👉 CNote
    //             url = `https://jaimarutilogistics.com/JaiAirTrackingApi/getTrackingData?CNoteNo=${searchValue}`;
    //         }

    //         const res = await axios.get(url);

    //         if (res.data.status === 1) {
    //             setTrackingData(res.data.Data);

    //             setSearchValue("");

    //             Swal.fire({
    //                 icon: "success",
    //                 title: "Tracking Found",
    //                 timer: 1200,
    //                 showConfirmButton: false,
    //             });

    //         } else {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "No Data Found",
    //             });
    //         }

    //     } catch {
    //         Swal.fire({
    //             icon: "error",
    //             title: "Error fetching data",
    //         });
    //     }
    // };


    const fetchData = async () => {
        try {
            if (!searchValue.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Enter Docket Number",
                    text: "📩 Please enter Docket No to get tracking details",
                });
                return;
            }

            // ✅ New API URL
            const url = `https://api.futureinfosys.in/Shreeramji/Master/getTrackingData?DocketNo=${searchValue}`;

            const res = await axios.get(url);

            // ✅ API Response Check
            if (res.data.status === 1 && res.data.Data.length > 0) {

                // First tracking object
                const tracking = res.data.Data[0];

                setTrackingData(tracking);

                setSearchValue("");

                Swal.fire({
                    icon: "success",
                    title: "Tracking Found",
                    timer: 1200,
                    showConfirmButton: false,
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "No Data Found",
                });
            }

        } catch (error) {
            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error fetching data",
                text: "Unable to fetch tracking details",
            });
        }
    };

    return (

        <>

            <header className="navbarheader-fluid">


                 <div className="top-bar">
                    Welcome to Shree Ram ji Courier & Logistics | +91 8543825903 - info@shreeramjicourierlogistics.com

                </div>

                {/* TOP BAR */}
                <div className="top-bar">
                    
                </div>

                {/* DESKTOP NAVBAR */}
                <div className="navbar-container d-none d-lg-flex">

                    <div className="navbar-logo">
                        <img src={ShreRamji} alt="logo" />
                    </div>

                    <nav className="navbar-links">
                        <a href="http://shreeramjicourierlogistics.com">Home</a>
                        <a href="#">About Us</a>
                        <a href="#">Services</a>
                        <a href="http://shreeramjicourierlogistics.com/NewLogin/#/login">Branch Login</a>
                        <a href="#">Document</a>
                        <a href="http://shreeramjicourierlogistics.com/contact.html">Contact</a>
                    </nav>

                </div>

                {/* MOBILE NAVBAR */}
                <nav className="navbar bg-light fixed-top d-lg-none">
                    <div className="container-fluid">

                        {/* MENU BUTTON */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* LOGO */}
                        <a className="navbar-brand ms-auto" href="#">
                            <img src={ShreRamji} alt="logo" />
                        </a>

                        {/* SIDEBAR MENU */}
                        <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <h5>Menu</h5>
                                <button className="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">

                                    <li><a href="http://shreeramjicourierlogistics.com/">Home</a></li>
                                    <li><a href="#">About Us</a></li>
                                    <li><a href="#">Services</a></li>
                                    <li><a href="http://shreeramjicourierlogistics.com/NewLogin/#/login">Branch Login</a></li>
                                    <li><a href="#">Document</a></li>
                                    <li><a href="http://shreeramjicourierlogistics.com/contact.html">Contact</a></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>

            </header>
            <div className="tracking-container">

                <div className="tracking-wrapper">

                    <h2 className="title">
                        Track a Shipment <span className="truck-icon">🚚</span>
                    </h2>

                    <p className="subtitle">
                        ⓘ Enter AWB Numbers in a separate line for advanced Tracking
                    </p>

                    <div className="input-box">
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setSearchValue(e.target.value)
                            }
                            placeholder="Enter AWB Number"
                        />
                    </div>

                    <div className="btn-group">
                        <button className="track-btn" onClick={fetchData}>
                            TRACK
                        </button>

                        <button
                            className="clear-btn"
                            onClick={() => setSearchValue("")}
                        >
                            CLEAR
                        </button>
                    </div>

                </div>

                {error && <p className="error">{error}</p>}

                {trackingData && (
                    <div className="result-section">

                        <div className="grid">

                            {/* LEFT */}
                            <div className="card">
                                <div className="card-header">Shipment Details</div>

                                <table className="shipment-table">
                                    <tbody>

                                        <tr>
                                            <td className="label">Docket No.</td>
                                            <td>{trackingData?.DocketNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Booking Date</td>
                                            <td>{trackingData?.BookDate}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Consignee</td>
                                            <td>{trackingData?.Consignee_Name}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Origin</td>
                                            <td>{trackingData?.OriginCity}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Destination</td>
                                            <td>{trackingData?.DestinationCity}</td>
                                        </tr>

                                        {/* <tr>
                                            <td className="label">Vendor AWB</td>
                                            <td>{trackingData?.VendorAwbNo}</td>
                                        </tr> */}

                                        <tr>
                                            <td className="label">Vendor AWB</td>
                                            <td>
                                                <a
                                                    href={getTrackingUrl(
                                                        trackingData?.VendorAwbNo,
                                                        trackingData?.Vendor_Name
                                                    )}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {trackingData?.VendorAwbNo}
                                                </a>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="label">Status</td>
                                            <td>{trackingData?.Status}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">DelvDT</td>
                                            <td>{trackingData?.DelvDT}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Weight</td>
                                            <td>{trackingData?.ActualWt} KG</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Qty</td>
                                            <td>{trackingData?.Qty}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Mode</td>
                                            <td>{trackingData?.Mode_Code}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            {/* RIGHT */}
                            <div className="card">
                                <div className="card-header">Shipping History</div>

                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Location</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {trackingData?.StatusEntry?.length > 0 ? (
                                                trackingData.StatusEntry.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.DelvDt}</td>
                                                        <td>{item.DelvTime}</td>
                                                        <td>{item.Destination_name}</td>
                                                        <td>{item.Status}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4}>No Tracking History</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                )}

                {/* FOOTER */}
                <footer className="footer-light">
                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}
                            <div className="footer-box">
                                <h3>Shree Ram Ji Courier Logistics</h3>

                                <h4>Ghansoli (Head Office)</h4>
                                <p>
                                    As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries. At <br /> <b>Shree Ram Ji Courier Logistics</b> WORLD WIDE LOGISTICS, client satisfaction is our top priority. We are committed to delivering reliable, efficient, and tailored solutions every time.
                                </p>
                            </div>

                            {/* COLUMN 2 */}
                            <div className="footer-box">
                                <h3>Shree Ram Ji Courier Logistics</h3>

                                <h4>Mumbai (Office)</h4>
                                <p>
                                    📍 Office No. 763, First Floor, Gouri Building, Goandevi Wadi, Ghansoli Gaon Main Rd, Ghansoli, Navi Mumbai - 400701
                                    📍
                                    Mumbai-400701
                                </p>

                                <p>📞 +91 8543825903</p>

                                <p>✉ info@shreeramjicourierlogistics.com</p>
                            </div>

                            {/* COLUMN 3 */}
                            <div className="footer-box">
                                <h3>SERVICES</h3>
                                <ul className="services-list">
                                    <li>Express Courier</li>
                                    <li>E-Commerce</li>
                                    <li>General Cargo</li>
                                    <li>Nominated Shipments</li>
                                    <li>Airline Consolidation</li>
                                    <li>Door to Door Cargo</li>
                                    <li>Dangerous Goods</li>
                                    <li>Cross Border Business</li>
                                    <li>Custom Brokerage</li>
                                </ul>
                            </div>

                            {/* ✅ NEW COLUMN 4 */}
                            <div className="footer-box">
                                <h3>QUICK LINKS</h3>
                                <ul className="services-list">
                                    <li>Home</li>
                                    <li>About Us</li>
                                    <li>Tracking</li>
                                    <li>Contact</li>
                                    <li>Privacy Policy</li>
                                    <li>Standard Conditions of Carriage</li>
                                    <li>Payment Terms and Conditions</li>
                                    <li>International Document</li>
                                    <li>Food Items</li>
                                    <li>Ecommerce Logistics</li>

                                </ul>
                            </div>

                        </div>

                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="footer-bottom-container">

                        <div className="footer-left">
                            © 2025 Shree Ram Ji Courier  Logistics All Rights Reserved.
                        </div>

                        <div className="footer-right">
                            <a href="#">Privacy & Policy</a>
                            <a href="#">Terms and Conditions</a>
                        </div>

                    </div>
                </div>

            </div>
        </>





    );
};

export default ShreeramjiTracking;